import(/* webpackMode: "eager" */ "/app/src/app/(marketing)/vouchers/[id]/loading.js");
